import { intervalToDuration, parseISO } from "date-fns";
import { useTimerProvider } from "../TimerProvider/index.js";
import "react/jsx-runtime";
import "react";
const useCounter = (time, options = {}) => {
  const { disabled } = options;
  const currentTime = useTimerProvider(disabled);
  const {
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0
  } = intervalToDuration({
    start: new Date(currentTime),
    end: parseISO(time)
  });
  const isLate = new Date(currentTime).getTime() > new Date(time).getTime();
  return {
    isLate,
    minutes,
    hours,
    seconds,
    days
  };
};
export {
  useCounter
};
